// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"47bc805e","703":"136492e8"}[chunkId] + ".chunk.js";
};